export default "__VITE_ASSET__BgXQmsJ1__"